import ScrollReveal from '../../../components/feature/ScrollReveal';

const numerals = ['1', '2', '3', '4'];

const timelineEvents = [
  {
    time: '16:45',
    title: 'Сбор гостей',
    description: 'Встреча гостей в Митинском ЗАГСе',
  },
  {
    time: '17:00',
    title: 'Роспись',
    description: 'Торжественная церемония бракосочетания в Митинском ЗАГСе',
  },
  {
    time: '19:00',
    title: 'Банкет',
    description: 'Праздничный ужин в Ресторане «Турандот»',
  },
  {
    time: '00:00',
    title: 'Завершение',
    description: 'Окончание торжества',
  },
];

export default function Timeline() {
  return (
    <section className="relative py-16 sm:py-32 px-4 sm:px-6" style={{ background: '#FDFAF4' }}>
      <div className="relative z-10 max-w-5xl mx-auto">

        <ScrollReveal direction="up">
          <div className="text-center mb-12 sm:mb-20 space-y-3">
            <h2 className="text-4xl sm:text-6xl md:text-7xl font-serif italic text-[#2A1A14]">
              Расписание дня
            </h2>
            <div className="flex items-center gap-3 justify-center pt-1">
              <div className="h-px w-12 bg-[#A8323C]/50" />
              <span className="text-[#A8323C] text-sm">✦</span>
              <div className="h-px w-12 bg-[#A8323C]/50" />
            </div>
          </div>
        </ScrollReveal>

        {/* Vertical timeline */}
        <div className="relative">
          {/* Vertical spine */}
          <div className="absolute left-8 sm:left-12 top-0 bottom-0 w-px bg-[#A8323C]/20 hidden md:block" />

          <div className="space-y-10 sm:space-y-14">
            {timelineEvents.map((event, index) => (
              <ScrollReveal key={index} direction="up" delay={index * 130}>
                <div className="relative flex flex-col md:flex-row gap-4 md:gap-12 items-start group">

                  {/* Roman numeral + time column */}
                  <div className="flex-shrink-0 md:w-52 flex flex-row md:flex-col items-center md:items-start gap-3">
                    {/* Spine dot */}
                    <div className="hidden md:flex absolute left-8 sm:left-12 -translate-x-1/2 mt-1 w-5 h-5 items-center justify-center"
                      style={{ top: '6px' }}>
                      <div className="w-3 h-3 rounded-full border-2 border-[#A8323C] bg-[#FDFAF4] group-hover:bg-[#A8323C] transition-colors duration-300" />
                    </div>

                    <span className="text-xs font-mono text-[#A8323C]/50 md:ml-8">{numerals[index]}</span>
                    <div className="text-2xl sm:text-4xl font-serif font-light text-[#A8323C] whitespace-nowrap md:ml-8 tracking-wide">
                      {event.time}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-shrink-0 md:flex-1 space-y-2 border-l-2 border-[#A8323C]/15 pl-5 md:border-l-0 md:pl-0
                                  group-hover:border-[#A8323C]/40 transition-colors duration-300">
                    <h3 className="text-2xl sm:text-3xl font-serif italic text-[#2A1A14]">
                      {event.title}
                    </h3>
                    {event.description && (
                      <p className="text-base text-[#6B5040] leading-relaxed">
                        {event.description}
                      </p>
                    )}
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
